import { Alert } from "../ui";
import React from "react";
import { useAuth } from "./AuthContext";
import { RoleGuard } from "./RoleGuard";

interface ProtectedRouteProps {
    children: JSX.Element;
    requiredPermission?: string;
    allowedRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredPermission, allowedRoles }) => {
    const { hasPermission } = useAuth();

    if (requiredPermission && !hasPermission(requiredPermission)) {
        // Authenticated but lacks permissions
        return (
            <div className="mx-auto max-w-2xl p-5">
                <Alert tone="danger">
                    <p className="font-semibold">Access Denied</p>
                    <p className="mt-1">
                        You do not have the required permissions ({requiredPermission}) to view this page.
                    </p>
                </Alert>
            </div>
        );
    }

    return <RoleGuard allowedRoles={allowedRoles}>{children}</RoleGuard>;
};
